var _defs, _line, _path, _line2, _line3, _line4, _line5, _line6, _rect, _rect2, _line7, _line8, _line9, _line10, _line11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGovernmentBuildingSvgrepoCom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#020202;stroke-miterlimit:10;stroke-width:1.91px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.35,
    y1: 8.15,
    x2: 19.65,
    y2: 8.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,3.37h0a4.78,4.78,0,0,1,4.78,4.78v0a0,0,0,0,1,0,0H7.22a0,0,0,0,1,0,0v0A4.78,4.78,0,0,1,12,3.37Z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12,
    y1: 0.5,
    x2: 12,
    y2: 3.37
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.09,
    y1: 11.98,
    x2: 10.09,
    y2: 22.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.91,
    y1: 11.98,
    x2: 13.91,
    y2: 22.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.74,
    y1: 8.15,
    x2: 17.74,
    y2: 22.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.26,
    y1: 8.15,
    x2: 6.26,
    y2: 22.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.74,
    y: 11.02,
    width: 4.78,
    height: 11.48
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.48,
    y: 11.02,
    width: 4.78,
    height: 11.48
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.52,
    y1: 22.5,
    x2: 23.48,
    y2: 22.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.39,
    y1: 14.85,
    x2: 6.26,
    y2: 14.85
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.39,
    y1: 18.67,
    x2: 6.26,
    y2: 18.67
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.74,
    y1: 14.85,
    x2: 20.61,
    y2: 14.85
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.74,
    y1: 18.67,
    x2: 20.61,
    y2: 18.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernmentBuildingSvgrepoCom);
export default __webpack_public_path__ + "static/media/government-building-svgrepo-com.1639ac025d9b2e1f1a01c8bef1b80fd8.svg";
export { ForwardRef as ReactComponent };